import { render, staticRenderFns } from "./typeImage.vue?vue&type=template&id=261638fa&"
import script from "./typeImage.vue?vue&type=script&lang=js&"
export * from "./typeImage.vue?vue&type=script&lang=js&"
import style0 from "./typeImage.vue?vue&type=style&index=0&id=261638fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports